<div
  class="overlay"
  lumAppLoader
  [loading]="loading"
  [classes]="'loading blur'"
></div>
<div class="location-warehouse-app-sku-selection">
  <div class="location-warehouse-app__header p-6">
    <h1 class="mat-h2 font-bold">{{ location?.location_name }}</h1>
  </div>

  <div class="location-app-sku__content p-6">
    <ng-container *ngIf="location?.rfqstock_locations?.length; else empty">
      <div class="location-sku-warehouse-selection">
        <table class="lum-table lum-table--classic striped">
          <tr>
            <th>SKU</th>
            <th>Product Name</th>
            <th class="text-right">Quantity</th>
            <th>Warnings</th>
          </tr>
          <tr
            *ngFor="
              let rfqstockLocation of location.rfqstock_locations;
              trackBy: trackById
            "
            class="cursor-pointer"
          >
            <td (click)="navigetToQuantityEntry(rfqstockLocation.id)">
              {{ rfqstockLocation?.rfq_stock?.rfq?.internal_sku }}
            </td>
            <td (click)="navigetToQuantityEntry(rfqstockLocation.id)">
              {{ rfqstockLocation?.rfq_stock?.rfq?.product_name }}
            </td>
            <td
              class="text-right"
              (click)="navigetToQuantityEntry(rfqstockLocation.id)"
            >
              {{ rfqstockLocation.onhand_quantity | decimalPlaces }}
            </td>
            <td>
              <lum-location-warehouse-app-picklist-total
                [picklistItems]="
                  rfqstockLocation?.rfq_stock?.rfq?.active_picklist_items
                "
              ></lum-location-warehouse-app-picklist-total>
            </td>
          </tr>
        </table>
      </div>
    </ng-container>

    <div class="mt-4 flex flex-column gap-4">
      <!-- <input type="text" class="lum-input" placeholder="Search SKU..." /> -->
      <lum-ui-autocomplete
        placeholder="Search SKU..."
        [loading]="loadingSku"
        [debounceTime]="500"
        [options]="rfqs"
        [displayProperty]="'product_name'"
        [value]="selectedSku?.product_name"
        (inputChangeEvent)="onInputChangeEvent($event)"
        (optionSelectedEvent)="onSkuSelectedEvent($event)"
      ></lum-ui-autocomplete>
      <button
        class="lum-button w-100"
        [disabled]="!selectedSku"
        (click)="onAddSku()"
      >
        Add
      </button>
      <button
        class="lum-button lum-button--secondary"
        (click)="toggleScanner = !toggleScanner"
      >
        {{ !toggleScanner ? 'Open Scanner' : 'Close Scanner' }}
      </button>

      <ng-container *ngIf="toggleScanner">
        <lum-ui-scanner
          [@slideUpAnimation]
          [@rollDownAnimation]
          [scannerConfig]="scannerConfig"
          (scanSuccess)="onScanned($event)"
          [activeDevice]="activeDevice"
        ></lum-ui-scanner>
      </ng-container>
    </div>
  </div>

  <ng-template #empty>
    <lum-ui-empty-page title="No records available."></lum-ui-empty-page>
  </ng-template>
</div>
